import Overlay from "../ux/Overlay";
import { FiBriefcase, FiFilePlus, FiEdit } from "react-icons/fi";

const services = [
    {
    service: "create your LLC",
    description:
      "Organize yor LLC in every state of the USA",
    icon: <FiBriefcase />,
    file: "llc.pdf",
  },
  {
    service: "obtain your EIN",
    description:
      "Most banks require an EIN to open a business checking account or credit account for the LLC",
    icon: <FiFilePlus />,
    file: "visa-extension.pdf",
  },
  {
    service: "help with LLC compliance",
    description:
      "Don't miss out your obligations as an LLC member",
    icon: <FiEdit />,
    file: "visa-status-change.pdf",
  },

];

const servicesMap = services.map((service, i) => {
  return (
    <article >
      <div className="notebook:w-3/4 text-[1.1rem] notebook:ml-[8rem] ">
        <div className="py-[.5rem] full:py-[1rem] text-gray-600 border-black border-b-2 mb-[1rem] desktop:mb-[1.5rem]">
          <p className="font-bold desktop:text-[1.8rem]  full:text-[2.2rem]">{service.service}</p>
          <p className="text-[.9rem] desktop:text-[1.3rem]  full:text-[1.5rem] font-light">
            {service.description}
          </p>
        </div>
      </div>
    </article>
  );
});

const ServicesSection = () => {
  return (
    <Overlay classes={"flex flex-col notebook:flex-row  py-[4rem]"}>
      <div className="font-bold text-[2rem] desktop:text-[3rem] full:text-[3.5rem] mb-[1rem] text-gray-600 notebook:w-[40%] desktop:w-[60%] ">
        our services
      </div>
      <div className="flex flex-col">{servicesMap}</div>
    </Overlay>
  );
};

export default ServicesSection;
